(function () {
  "use strict";

  angular.module("sempraWebapp").directive("layoutHeader", headerInject);

  /** @ngInject */
  function headerInject($window) {
    var directive = {
      restrict: "E",
      templateUrl: "app/components/header/header.html",
      controller: HeaderController,
      controllerAs: "vm",
      scope: {},
      replace: true,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function HeaderController(
      $scope,
      $mdSidenav,
      $state,
      $log,
      sessionData,
      HeaderAlarmsViewModel,
      MyAccountViewModel,
      $mdDialog,
      $mdMenu,
      $translate,
      deviceActions,
      messageActions,
      userActions,
      webSocketsStore,
      broker,
      version,
      brand,
      checkUserRole
    ) {
      var vm = this,
        _webSocketStoreConnectedChangeHandler = subscribeToSocket,
        _onMessageAvailableHandler = refreshAlarms;

      vm.notifications = 5;
      vm.version = version;
      vm.brand = brand;

      vm.openMobileMenu = buildToggler("left");

      vm.alarmsViewModel = new HeaderAlarmsViewModel();
      vm.myAccount = new MyAccountViewModel();

      vm.gotoHelp = function () {
        switch (brand) {
          case "karcher":
            $window.open("https://www.kaercher.com/", "_blank");
            break;
          default:
            $state.go("app.help");
            break;
        }
      };

      vm.goTermsAndServices = function (marker) {
        $state.go("app.termsAndService", { marker: marker });
      };

      vm.closeMobileMenu = function () {
        $mdSidenav("left").close();
      };

      vm.doLogout = function (ev) {
        // open confirmation dialog
        var confirm = $mdDialog
          .confirm()
          .title($translate.instant("LOGOUT_TITLE"))
          .textContent($translate.instant("LOGOUT_MSG"))
          .ariaLabel("logout confirmation dialog")
          .targetEvent(ev)
          .ok($translate.instant("SIGN_OUT"))
          .cancel($translate.instant("CANCEL"));
        $mdDialog.show(confirm).then(
          function () {
            // after success do logout
            sessionData.clearAll();
            if (broker.isConnected()) {
              broker.unsubscribeSocket();
              broker.disconnectSockets();
            }
            $state.go("login");
          },
          function () {
            $scope.status = "You decided to keep login.";
          }
        );
      };

      vm.openMenu = function ($mdMenu, ev) {
        $mdMenu.open(ev);
      };

      vm.showAdvanced = function (ev) {
        $mdDialog.show({
          controller: modalController,
          controllerAs: "vm",
          bindToController: true,
          templateUrl: "app/components/header/headerMyAccountModalView.html",
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          clickOutsideToClose: true
        });
        $mdMenu.hide();
      };

      // MODAL VIEW CONTROLLER ==================================================================================
      // TO-DO move to separate file
      function modalController($mdDialog, userActions) {
        var that = this;

        // set initial values
        that.username = vm.myAccount.username;
        that.firstName = vm.myAccount.firstName;
        that.lastName = vm.myAccount.lastName;
        that.userRole = vm.myAccount.userRole;
        that.oldPassword = vm.myAccount.oldPassword;
        that.newPassword = vm.myAccount.newPassword;
        that.newPasswordRepeat = vm.myAccount.newPasswordRepeat;
        that.passwordIdentical = false;
        that.passwordNotMatch = false;
        that.newsLetter = vm.myAccount.newsLetter;

        that.checkPasswordChangeRequest = function () {
          return (
            that.oldPassword !== "" &&
            that.newPassword !== "" &&
            that.newPasswordRepeat !== ""
          );
        };

        // on each input change call updateInfo method to validate
        that.updateInfo = function (param, form) {
          var myAccountForm = form;
          switch (param) {
            case "new_password":
              that.passwordIdentical =
                myAccountForm.oldPassword.$viewValue ===
                myAccountForm.newPassword.$viewValue;
              if (
                that.passwordIdentical &&
                myAccountForm.oldPassword.$viewValue !== "" &&
                myAccountForm.newPassword.$viewValue !== ""
              ) {
                myAccountForm.newPassword.$setValidity("prop", false);
              } else {
                myAccountForm.newPassword.$setValidity("prop", true);
              }
              that.passwordNotMatch =
                myAccountForm.newPassword.$viewValue !==
                  myAccountForm.repeatNewPassword.$viewValue &&
                myAccountForm.repeatNewPassword.$viewValue !== "";

              break;
            case "repeat_new_password":
              that.passwordNotMatch =
                myAccountForm.newPassword.$viewValue !==
                myAccountForm.repeatNewPassword.$viewValue;
              if (that.passwordNotMatch) {
                myAccountForm.$setValidity("prop", false);
              } else {
                myAccountForm.$setValidity("prop", true);
              }
              break;
          }
        };
        // on form submit get all input values from model and call api action to submit
        that.saveChanges = function (myAccountForm) {
          var userInfoData = {
            firstName: myAccountForm.firstName.$modelValue,
            lastName: myAccountForm.lastName.$modelValue,
            receiveEmailNotificationsSelected:
              myAccountForm.newsLetter.$modelValue
          };

          var passwordData = {
            oldPassword: myAccountForm.oldPassword.$modelValue,
            newPassword: myAccountForm.newPassword.$modelValue
          };

          // call change password action
          if (passwordData.oldPassword && passwordData.newPassword.length > 0) {
            userActions.changePassword(passwordData).then(function () {
              $log.log("Password was successfully changed");
            });
          }

          // call update user info action
          if (
            userInfoData.firstName.length > 0 &&
            userInfoData.lastName.length > 0
          ) {
            userActions.updateUserInfo(userInfoData).then(function (data) {
              $log.log("Basic info was successfully changed");
              vm.myAccount.firstName = data.firstName;
              vm.myAccount.lastName = data.lastName;
              vm.myAccount.newsLetter = data.receiveEmailNotificationsSelected;
              sessionData.setValue(
                sessionData.Keys.RECEIVE_EMAIL,
                data.receiveEmailNotificationsSelected
              );
            });
          }

          that.closeDialog();
        };

        that.closeDialog = function () {
          $mdDialog.hide();
        };
      } // end of modal controller =============================================================

      vm.goToMessagesPage = function () {
        $state.go("app.alarms");
        $mdMenu.hide();
      };

      vm.goToFacilityDetails = function (deviceSerial) {
        $state.go("app.dashboardTechnology.facilityDetails", {
          id: deviceSerial
        });
        $mdMenu.hide();
      };

      vm.gotoReleaseNotesPage = function() {
        $state.go("app.releaseNotes");
        $mdMenu.hide();
      }

      vm.checkUserForUserAccountManagement = function() {
        return checkUserRole.isAdministrator() || checkUserRole.isMerchantAdmin();
      }

      init();

      function init() {
        $scope.$on("$destroy", destroy);
        if (brand !== "karcher") {
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.MESSAGES_UPDATE_AVAILABLE,
            _onMessageAvailableHandler
          );

          subscribeToSocket();
          refreshAlarms();
        }
      }

      function subscribeToSocket() {
        if (webSocketsStore.isConnected()) {
          var deviceSerialArray = sessionData.getValue(
            sessionData.Keys.TOPICS_LIST
          );
          broker.subscribeToMessageChanges(deviceSerialArray);
        }
      }

      function refreshAlarms() {
        if (checkUserRole.hasAcceptNewTerms(sessionData.getValue('userRole'))) {
          return;
        }
        messageActions.getAlarmMessages();
      }

      function destroy() {
        vm.alarmsViewModel.destroy();
        vm.myAccount.destroy();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.MESSAGES_UPDATE_AVAILABLE,
          _onMessageAvailableHandler
        );
      }

      function buildToggler(navID) {
        return function () {
          $mdSidenav(navID).toggle();
        };
      }
    }
  }
})();
